export default "skymp5-front/618c2ec90efb46a0a6dd2d8aa2daa220.gif";